import ProgressSVG from '@shared/assets/images/icons/icon-progress.svg?react'
import theme from '@theme'

import IconWrapper from './IconWrapper'

// svg 有要改顏色就放 src/assets/images 打包進 bundle
export const ProgressIcon = ({
  color = theme.colors.white,
  marginLeft,
}: {
  color?: string
  marginLeft?: number
}) => (
  <IconWrapper isRotate marginLeft={marginLeft}>
    <ProgressSVG fill={color} />
  </IconWrapper>
)

export default ProgressIcon
